export const CNVG = 'cnvg';
export const LAMS = 'lams';
export const L4B = 'l4b';
